import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { TerminateModal } from 'components/terminate-modal/terminate-modal';
import { useCachedUserType, useTranslation } from 'hooks';
import { useSubscriptions } from 'hooks/api/useSubscriptions';
import { Fragment, useEffect, useState } from 'react';
import { ICONS } from 'shared/constants/images';
import { Card } from 'shared/ui/card/card';
import IconButton from 'shared/ui/iconButton/icon-button';
import { PageCloseButton } from 'shared/ui/pageCloseButton/page-close-button';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setShowBanner } from 'store/slices/userSlice';
import cls from './subscriotions-page.module.scss';
import { Billing } from './ui/billing/billing';
import { Subscriptions } from './ui/subscriptions';
import { Websites } from './ui/websites';
import { LanguageSelect } from 'components/language-select/language-select';

export const SubscriptionsPage: React.FC = () => {
  const { t } = useTranslation();
  const [terminateModalOpen, setTerminateModalOpen] = useState(false);
  const [tab, setTab] = useState<number>(0);
  const [subscriptionQuantity, setSubscriptionQuantity] = useState(1);

  const { isKa, isDirect } = useCachedUserType();
  const { terminated } = useSubscriptions();
  const dispatch = useAppDispatch();
  const showBanner = useAppSelector(state => state.user.showSubBanner);

  const handleBannerClose = () => {
    dispatch(setShowBanner(false));
  };

  useEffect(() => {
    if (isKa && terminated.length > 0) {
      setTerminateModalOpen(true);
    }
  }, [terminated.length, isKa]);
  return (
    <div className={cls.subscriptionsPage}>
      <PageCloseButton to={'../'} aria-label={t('close')} />
      <div className={cls.page}>
        {showBanner && (
          <Card className={cls.banner}>
            <div>
              <p className={cls.bannerText}>{t('subscriptionIsReady')}</p>
              <p className={cls.bannerSubText}>
                {t('subscriptionIsReadyDescription')}
              </p>
            </div>
            <IconButton
              onClick={handleBannerClose}
              pathToIcon={ICONS.crossBlack}
            />
          </Card>
        )}
        <TabGroup selectedIndex={tab} onChange={index => setTab(index)}>
          <Card className={`${cls.topCard} ${tab === 0 ? cls.websites : ''}`}>
            <div className={cls.pageHeader}>
              <h1 className={cls.pageTitle}>{t('subscriptionManagement')}</h1>
            </div>
            <TabList className={cls.tabList}>
              <Tab as={Fragment}>
                {({ selected }) => (
                  <button
                    className={`${cls.tab} ${selected ? cls.active : ''}`}
                  >
                    {t('websites')}
                  </button>
                )}
              </Tab>
              <Tab as={Fragment}>
                {({ selected }) => (
                  <button
                    className={`${cls.tab} ${selected ? cls.active : ''}`}
                  >
                    {t('licenses')}
                  </button>
                )}
              </Tab>
              {isDirect && (
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`${cls.tab} ${selected ? cls.active : ''}`}
                    >
                      {t('billing')}
                    </button>
                  )}
                </Tab>
              )}
            </TabList>
          </Card>
          <TabPanels>
            <TabPanel>
              <Websites
                subscriptionQuantity={subscriptionQuantity}
                onSubscriptionQuantityChange={setSubscriptionQuantity}
              />
            </TabPanel>
            <TabPanel>
              <Subscriptions
                subscriptionQuantity={subscriptionQuantity}
                onSubscriptionQuantityChange={setSubscriptionQuantity}
                onNavigateToWebsites={() => setTab(0)}
              />
            </TabPanel>
            {isDirect && (
              <TabPanel>
                <Billing />
              </TabPanel>
            )}
          </TabPanels>
        </TabGroup>
      </div>
      {isKa && (
        <TerminateModal
          isOpen={terminateModalOpen}
          onClose={() => setTerminateModalOpen(false)}
        />
      )}
      <div className={cls.languageSelect}>
        <LanguageSelect />
      </div>
    </div>
  );
};
